var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.41 20.82c2.31 0 4.554-.773 6.373-2.196l5.721 5.72 1.84-1.84-5.72-5.72a10.35 10.35 0 0 0 2.198-6.374C20.822 4.67 16.15 0 10.41 0S0 4.67 0 10.41s4.67 10.41 10.41 10.41m0-18.217c4.307 0 7.809 3.501 7.809 7.807s-3.502 7.808-7.808 7.808-7.808-3.502-7.808-7.808 3.502-7.807 7.808-7.807"
  })));
};
export default SvgSearch;